module.exports = __webpack_public_path__ + "img/andorra.a5842b7c.svg";